import type { ReactNode } from 'react';

export function Loading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="row" style={{ gap: 10, color: 'var(--text-dim)', padding: '28px 4px' }}>
      <span className="spinner" />
      <span className="mono" style={{ fontSize: 13 }}>{label}…</span>
    </div>
  );
}

export function ErrorBanner({ error }: { error: unknown }) {
  const msg =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unexpected error';
  return (
    <div
      className="card"
      style={{
        borderColor: 'rgba(255,93,108,0.35)',
        background: 'rgba(255,93,108,0.06)',
        color: 'var(--loss)',
      }}
    >
      <div className="eyebrow" style={{ color: 'var(--loss)' }}>error</div>
      <div className="mono" style={{ fontSize: 13, marginTop: 4 }}>{msg}</div>
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div
      className="panel"
      style={{ padding: '44px 24px', textAlign: 'center', borderStyle: 'dashed' }}
    >
      <div className="eyebrow">no data</div>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, marginTop: 8 }}>{title}</div>
      {hint && <div className="dim" style={{ marginTop: 6, fontSize: 14 }}>{hint}</div>}
      {action && <div style={{ marginTop: 18 }}>{action}</div>}
    </div>
  );
}
